// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-53c128e0] {\n  max-height: calc(100vh - 340px) !important;\n}\n.cell-ns[data-v-53c128e0] {\n  font-size: 13px;\n  text-transform: lowercase;\n}", ""]);
// Exports
module.exports = exports;
